import React from 'react'
import Table from '../table/table'
import { AppHeader } from 'src/business/components'

const Members = () => {
  return (
    <>
      <AppHeader heading="Members" />
      <Table />
    </>
  )
}

export default Members
